import { Component, OnInit } from '@angular/core';

declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'design_app', class: '' },
    { path: '/ads', title: 'Ads',  icon: 'education_atom', class: '' },
    { path: '/payments', title: 'Payments',  icon: 'location_map-big', class: '' },
  /*  { path: '/category-master', title: 'Category',  icon: 'education_atom', class: '' },
    { path: '/cities', title: 'City',  icon: 'education_atom', class: '' },
    { path: '/places', title: 'Place',  icon: 'education_atom', class: '' },
    { path: '/reviews', title: 'Reviews',  icon: 'education_atom', class: '' },
    { path: '/images', title: 'Images',  icon: 'education_atom', class: '' }
       { path: '/buyer', title: 'Buyers',  icon: 'education_atom', class: '' },
    { path: '/posts', title: 'Posts',  icon: 'location_map-big', class: '' },
    { path: '/notifications', title: 'Notifications',  icon: 'location_map-big', class: '' }
   { path: '/product-order', title: 'Product Orders',  icon: 'ui-1_bell-53', class: '' }

  { path: '/icons', title: 'Icons',  icon:'education_atom', class: '' },
    { path: '/maps', title: 'Maps',  icon:'location_map-big', class: '' },
    { path: '/notifications', title: 'Notifications',  icon:'ui-1_bell-53', class: '' },

    { path: '/user-profile', title: 'User Profile',  icon:'users_single-02', class: '' },
    { path: '/table-list', title: 'Table List',  icon:'design_bullet-list-67', class: '' },
    { path: '/typography', title: 'Typography',  icon:'text_caps-small', class: '' }*/
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ( window.innerWidth > 991) {
          return false;
      }
      return true;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts